import K_Scheduler from "../templates/K_Scheduler";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface SchedulerOptions extends ComponentOptions, kendo.ui.SchedulerOptions {
    bsc?: string;
    style?: string;
    header?: string;
    observable?: any;
    label?: string;
    screenEntityName?: string;
    title?: string;
    readOnly?: boolean;
    readonly?: boolean;
    height?: number;
    labelBsc?: string;
    childBsc?: string;
    childInputBsc?: string;
    childLabelBsc?: string;
    entityType?: string;
    ScreenEntityType?: string;

    views?: any[];
}

export class Scheduler extends TemplateComponent {

    options: SchedulerOptions;

    constructor(options: SchedulerOptions) {
        super(K_Scheduler, options);
    }

    preRender() {
        this.options.screenEntityType = this.options.screenEntityType || "";
    }

    create() {
        $("#" + this.options.id).attr("screenentitytype", this.options.screenEntityType);

        this.options.date = this.options.date || new Date();
        this.options.startTime = this.options.startTime || new Date();
        this.options.height = this.options.height || 600;
        this.options.views = this.options.views || [ "day", "week", { type: "month", selected: true } ];

        $("#" + this.options.id).kendoScheduler(this.options);
    }

}
